<template>
  <div class="row poppins h-100">
    <div class="col-12 h-100">
      <div class="table-wrapper h-100 d-flex flex-column">
        <div class="filter-block mb-0">
          <div class="d-flex mb-3 pb-1">
            <span class="search-wrapper">
              <SearchInput :searchChange="searchChange" />
            </span>
            <div class="status-buttons-block">
              <div
                v-for="btn in statusButtons"
                :key="btn.value"
                @click="statusChange(btn.value)"
                :class="`status-button ${filter.status === btn.value ? 'status-button-active' : ''}`"
              >
                <div v-if="btn.color" :class="`dot ${btn.color}-status`"></div>
                {{ btn.name | i18n }}
              </div>
            </div>
            <b-button variant="outline-primary" size="sm" class="ml-2 color-blue-light" @click="importCase">
              <ImportIcon class="mr-1" />
              {{ 'Import' | i18n }}
            </b-button>
            <b-button variant="outline-primary" size="sm" class="ml-2 color-blue-light" :disabled="!selectedList.length" @click="exportCase">
              <ImportIcon class="mr-1 rotate-180" />
              {{ 'Export' | i18n }}
            </b-button>
            <ImportCaseInfo :nonImportedCaseList="nonImportedCaseList" />
          </div>
          <!-- <div class="date-range-block">
            <date-range-picker :update="dateRangeChange" />
          </div> -->
          <div class="d-flex mb-3 pb-1">
            <b-button
              v-b-modal.update-case-list
              variant="primary"
              size="lg"
              class="pl-3 pr-4 d-flex align-items-center"
              :disabled="!selectedList.length"
            >
              {{ 'Update case list' | i18n }}
            </b-button>
            <UpdateCaseListModal :id-list="selectedList" />
            <b-button variant="primary" size="lg" class="ml-3 pl-3 pr-4 d-flex align-items-center" @click="goToNewCasePage">
              <BIconPlus class="mr-2" />
              {{ 'new_case' | i18n }}
            </b-button>
            <b-button
              v-if="CAN_DELETE.includes(auth.role)"
              variant="outline-danger"
              size="lg"
              class="ml-3 pl-4 pr-4 d-flex align-items-center"
              :disabled="!selectedList.length"
              @click="deleteCases"
            >
              <img :src="deleteIconUrl" class="mr-2" />
              {{ 'remove_case' | i18n }}
            </b-button>
          </div>
        </div>
        <Table
          :update="getPage"
          :columns="columns"
          :rows="rows"
          :filter="filter"
          :updateFilter="updateFilter"
          :loadingInstance="loadingInstance"
          :setLoadingInstance="setLoadingInstance"
          :selectedList="selectedList"
          :setSelectedList="setSelectedList"
          class="overflow-auto pr-1"
          tableName="casesTable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { BIconArrowRightShort, BIconPlus, BIconSearch } from 'bootstrap-vue';
import DateRangePicker from 'vue2-daterange-picker';

import { ReportsMixin, DeleteRowMixin, NotificationMixin, AuthMixin } from '../../../../mixins';
import Table from '../../common/table';
import SearchInput from '../../common/search-input';
import { CASE_STATUSES, CAN_DELETE } from '../../../../../../../constants';
import DeleteIcon from '../../../../assets/icons/delete.svg';
import DetailsIcon from '../../../../assets/icons/iconsCode/details.vue';
import ImportIcon from '../../../../assets/icons/iconsCode/import';
import ImportCaseInfo from './import-case-info-modal';
import UpdateCaseListModal from './update-case-list-modal';

let inputInterval = null;

export default {
  title: 'Cases',
  components: { BIconPlus, BIconSearch, Table, SearchInput, DateRangePicker, DetailsIcon, ImportIcon, ImportCaseInfo, UpdateCaseListModal },
  mixins: [ReportsMixin, DeleteRowMixin, NotificationMixin, AuthMixin],
  data() {
    return {
      nonImportedCaseList: [],
      localBasePath: axios.defaults.baseURL,
      accessToken: '',
      deleteIconUrl: DeleteIcon,
      selectedList: [],
      loadingInstance: null,
      CAN_DELETE: CAN_DELETE,
      filter: {
        page: 1,
        limit: 10,
        totalCount: 0,
        sortBy: 'createdAt',
        sortOrder: 'desc',
        status: '',
        dateRange: {},
        searchQuery: '',
      },
      statusButtons: [
        {
          name: 'All',
          value: '',
        },
        {
          name: 'Active',
          value: CASE_STATUSES.ACTIVE,
          color: 'active',
        },
        {
          name: 'In Progress',
          value: CASE_STATUSES.IN_PROGRESS,
          color: 'inprogress',
        },
        {
          name: 'Finished',
          value: CASE_STATUSES.FINISHED,
          color: 'finished',
        },
      ],
      columns: [
        {
          field: 'status',
          key: 'status',
          title: '',
          width: 0,
          renderBodyCell: ({ row, column }) => {
            const cellData = row[column.field];
            const color = (() => {
              switch (cellData) {
                case CASE_STATUSES.ACTIVE:
                  return 'active';
                case CASE_STATUSES.IN_PROGRESS:
                  return 'inprogress';
                case CASE_STATUSES.FINISHED:
                  return 'finished';
              }
            })();
            return (
              <div class={`status-cell ${color}-status`} />
            );
          },
        },
        {
          field: 'caseNumber',
          title: '#',
          width: 100,
          key: '2',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }, h) => row.caseNumberString,
        },
        {
          field: 'teamName',
          title: this.$translate('team'),
          key: '4',
          align: 'left',
        },
        {
          field: 'title',
          title: this.$translate('title'),
          key: '5',
          align: 'left',
          sortBy: '',
        },
        {
          field: 'template.name',
          title: this.$translate('template'),
          key: '7',
          align: 'left',
          sortBy: '',
          renderBodyCell: ({ row }, h) => row.templateTitle,
        },
        {
          field: 'userName',
          title: this.$translate('Assigned User'),
          key: '6',
          width: 200,
        },
        {
          field: 'createdAt',
          title: this.$translate('Date Created'),
          key: '8',
          sortBy: 'desc',
          width: 200,
        },
        {
          field: 'actions',
          key: 'actions',
          title: '',
          width: 50,
          renderBodyCell: ({ row }) => {
            return (
              <b-button variant="primary" size="sm" class="p-2 size-12" on-click={() => this.goToEditCase(row.id)}>
                <DetailsIcon />
              </b-button>
            );
          },
        },
      ],
      rows: [],
    };
  },
  created() {
    const auth = this.authStorageService.getAuth();
    this.accessToken = auth.access_token_link;

    if (this.CAN_DELETE.includes(this.auth.role)) {
      const columns = [...this.columns];
      columns.splice(1, 0, {
        field: 'check',
        key: 'check',
        type: 'checkbox',
        title: '',
        width: 50,
        align: 'center',
      });
      this.columns = columns;
    }
  },
  methods: {
    async importCase() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.xlsx, .csv';
      input.onchange = async (e) => {
        let isWrongImportFile = false;
        try {
          const file = e.target.files[0];
          const result = await this.reportsService.importCases(file);

          if (result.data.isDuplicateCase) {
            const isPossibleDuplicate = window.confirm(this.$translate('Are you sure that you want duplicate cases?'));
            if (isPossibleDuplicate) {
              const res = await this.reportsService.importAllCases(file);
              this.nonImportedCaseList = res.data.nonImportedCaseList;
              isWrongImportFile = res.data.isWrongImportFile;
            } else {
              const res = await this.reportsService.importUniqueCases(file);
              this.nonImportedCaseList = res.data.nonImportedCaseList;
              isWrongImportFile = res.data.isWrongImportFile;
            }
          } else {
            const res = await this.reportsService.importAllCases(file);
            this.nonImportedCaseList = res.data.nonImportedCaseList;
            isWrongImportFile = res.data.isWrongImportFile;
          }
  
          if (this.nonImportedCaseList.length) {
            this.nonImportedCaseList = this.nonImportedCaseList.map((caseData) => {
              const emptyFields = [];
              for (const caseDataKey in caseData) {
                if (!caseData[caseDataKey]) {
                  emptyFields.push(caseDataKey);
                }
              }
              return { ...caseData, emptyFields: emptyFields.join(', ') };
            });
            this.$root.$emit('bv::show::modal', 'import-case-info');
          } else if (isWrongImportFile) {
            throw new Error(this.$translate('File have a wrong format'));
          } else {
            this.showNotification({ type: 'success', message: this.$translate('Cases was successfully imported!') });
          }
        } catch (error) {
          this.showNotification({
            type: 'error',
            message: isWrongImportFile ? error.message : this.$translate('Cases was not imported!'),
          });
        }

        await this.getPage();
      };

      input.click();
    },
    async exportCase() {
      const ids = this.selectedList.map((r) => r.id);
      const idsQuery = ids.map((id) => id).join(',');
      try {
        const url = `${this.localBasePath}/api/v1/reports/cases-export?ids=${idsQuery}&authorization=${this.accessToken}`;
        await axios(url);
        window.open(url, '_blank');
      } catch (error) {
        this.showNotification({ type: 'error', message: this.$translate('Cases was not exported!') });
      }
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setSelectedList(list) {
      this.selectedList = list;
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    searchChange(e) {
      const v = e.target.value;
      this.filter.searchQuery = v;
      if (inputInterval) {
        clearTimeout(inputInterval);
      }
      inputInterval = setTimeout(() => {
        this.getPage();
      }, 500);
    },
    dateRangeChange(date) {
      this.filter.dateRange = {
        endDate: date.endDate ? moment(date.endDate).format('YYYY-MM-DD') : '',
        startDate: date.startDate ? moment(date.startDate).format('YYYY-MM-DD') : '',
      };
      this.getPage();
    },
    statusChange(status) {
      this.filter.status = status;
      this.getPage();
    },
    goToNewCasePage() {
      this.$router.push({ name: 'new-case' });
    },
    goToEditCase(id) {
      this.$router.push({ name: 'case-details', params: { id } });
    },
    async deleteCases() {
      try {
        await this.deleteSelectedRows(
          {
            message: this.$translate('case_delete_message'),
            rowDisplayValues: this.selectedList.map((r) => r.caseNumberString),
          },
          async () => {
            const ids = this.selectedList.map((r) => r.id);
            await this.reportsService.deleteCases({ ids });
            this.rows = this.rows.filter((i) => !ids.includes(i.id));
            this.selectedList = [];
            this.getPage();
          }
        );
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    async getPage() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder, status, dateRange, searchQuery } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        if (status) {
          ctx.status = status;
        }
        if (dateRange && dateRange.startDate && dateRange.endDate) {
          ctx.startDate = dateRange.startDate;
          ctx.endDate = dateRange.endDate;
        }
        const response = await this.reportsService.getCasesPage(ctx);
        response.data = response.data.map((item) => ({
          ...item,
          teamName: item.team.name,
          createdAt: moment(item.createdAt).format('DD.MM.YY HH:mm'),
          templateTitle: item.template.name,
          userName: item.user.name,
        }));
        this.filter.totalCount = response.totalCount;
        this.stopLoading();
        this.rows = response.data;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ve-table-body {
  ::v-deep th {
    color: rgb(112, 112, 112) !important;
    background-color: rgb(239, 239, 239) !important;
    border: none !important;
    min-height: 50px;
  }
  ::v-deep td {
    color: rgb(112, 112, 112) !important;
    cursor: pointer;
  }
}

::v-deep .ve-table-cell-selection {
  border: none !important;
}

::v-deep .ve-table-sort {
  top: -4.5px;
}

::v-deep .details-action {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgb(34, 129, 254);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 28px;
  margin: auto;
}

::v-deep .status-cell {
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  border-radius: 0 2px 2px 0;
}
::v-deep .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
::v-deep .active-status {
  background-color: rgb(37, 154, 43);
}
::v-deep .inprogress-status {
  background-color: rgb(239, 255, 15);
}
::v-deep .finished-status {
  background-color: rgb(90, 98, 107);
}

.status-button {
  border: 1px solid #c5d0de;
  padding: 8px 16px;
  cursor: pointer;
  white-space: nowrap;
  font-size: 14px;
  line-height: 16px;
  color: rgba(100, 106, 135, 0.6);
  display: flex;
  align-items: center;
  &:first-child {
    border-radius: 4px 0px 0px 4px;
  }
  &:last-child {
    border-radius: 0px 4px 4px 0px;
  }
}

.status-button-active {
  color: #2260ff;
  background: rgba(34, 96, 255, 0.1);
  border: 1px solid #2260ff;
}

.search-wrapper {
  margin-right: 10px;
  display: flex;
  align-items: center;
}

.status-buttons-block {
  display: flex;
  flex-wrap: wrap;
}

.statuses-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.status-block {
  display: flex;
  margin-left: 20px;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.status-name {
  margin-left: 10px;
  font-size: 14px;
}

.date-range-block {
  min-width: 350px;
  text-align: center;
  margin-left: 30px;
  display: flex;
  align-items: center;
}

::v-deep .ve-select-selected-span {
  font-weight: 400;
}

.pagination-block {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}

::v-deep .size-12 {
  font-size: 12px;
  line-height: 12px;
}

.rotate-180 {
  transform: rotate(180deg);
}
</style>
